import {connect} from "react-redux";
import List from "./List";
import {bindActionCreators} from "redux";
import {activityList} from "../../../service/Activity/action";
import {isCheckout} from "../../../service/CarService/action";
import {markAttendance} from "../../../service/DCC/action";
import {accountDetailsById} from "../../../service/Account/action";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";
import {ratingSave} from "../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    activityListDetails:state.Activity.activityList,
    attendance:state.DCC.attendance,
    isCheckoutDetails:state.CarService.isCheckout,
    accountDetails:state.Dropdown.accountDetailsById,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    savedRating: state.Dealer.savedRating,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            activityList,
            isCheckout,
            markAttendance,
            accountDetailsById,
            documentUploadUrlPublic,
            ratingSave
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(List);
